/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, lazy, Suspense, useMemo, useContext } from "react";
import {
  getDocumentos,
  eliminarNormativa,
  exportarDocumentosExcel,
} from "../../componentes/http/actions/DocumentoAction";
import { reanalizarImpacto } from "../../componentes/http/actions/ImpactoAction";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  Typography,
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
  useTheme,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Autocomplete,
  CircularProgress,
  IconButton,
  Tooltip,
  Divider,
  Chip,
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from '@mui/icons-material/Download';
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ReplayIcon from "@mui/icons-material/Replay";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DataLoader from "../../componentes/data/DataLoader";
import { NotificacionContext } from "../../componentes/common/NotificacionContext";

const LazyDetalleNormativaModal = lazy(() => import('../../componentes/modal/Normativa/DetalleNormativaModal'));

const FILTERS_STORAGE_KEY = 'gestorNormativaFilters';

const ORDEN_DEFECTO = { ordenarPor: "fechaCreacion", ordenDireccion: "desc" };

const saveFiltersToStorage = (filters) => {
  try {
    sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filters));
  } catch (error) {
    console.error('Error al guardar filtros:', error);
  }
};

const loadFiltersFromStorage = () => {
  try {
    const saved = sessionStorage.getItem(FILTERS_STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed.startDate) parsed.startDate = new Date(parsed.startDate);
      if (parsed.endDate) parsed.endDate = new Date(parsed.endDate);
      return parsed;
    }
  } catch (error) {
    console.error('Error al cargar filtros:', error);
  }
  return null;
};

const GestorNormativa = () => {
  const savedFilters = loadFiltersFromStorage();

  const [documentos, setDocumentos] = useState([]);
  const [searchTerm, setSearchTerm] = useState(savedFilters?.searchTerm || "");
  const [filterHabilitado, setFilterHabilitado] = useState(savedFilters?.filterHabilitado || "todos");
  const [searchField] = useState("nombre");
  const navigate = useNavigate();
  const [openDetalleNormativaModal, setOpenDetalleNormativaModal] = useState(false);
  const [normativaSeleccionado, setNormativaSeleccionado] = useState(null);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [isLoadingNormativas, setIsLoadingNormativas] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [reanalizandoId, setReanalizandoId] = useState(null);
  const [reanalizadasIds, setReanalizadasIds] = useState(() => new Set());
  const { mostrarNotificacion } = useContext(NotificacionContext);

  const [page, setPage] = useState(savedFilters?.page || 0);
  const [rowsPerPage, setRowsPerPage] = useState(savedFilters?.rowsPerPage || 10);
  const [totalCount, setTotalCount] = useState(0);

  const [startDate, setStartDate] = useState(savedFilters?.startDate || null);
  const [endDate, setEndDate] = useState(savedFilters?.endDate || null);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [normativaToDelete, setNormativaToDelete] = useState(null);

  const [ordenarPor, setOrdenarPor] = useState(savedFilters?.ordenarPor || ORDEN_DEFECTO.ordenarPor);
  const [ordenDireccion, setOrdenDireccion] = useState(savedFilters?.ordenDireccion || ORDEN_DEFECTO.ordenDireccion);

  const [loadedData, setLoadedData] = useState({
    organismos: [],
    tiposDocumento: [],
    estadosTramitacion: [],
    rubros: [],
    clasificaciones: [],
    clientes: [],
    paises: [],
  });

  const [selectedFilters, setSelectedFilters] = useState(savedFilters?.selectedFilters || {
    organismoEmisorId: null,
    tipoDocumentoId: null,
    estadoTramitacionId: null,
    rubroId: null,
    clasificacionDocumentoId: null,
    clienteId: null,
    paisId: null,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const isMedium = useMediaQuery(theme.breakpoints.down("lg"));

  const handleDataLoaded = useCallback((data) => {
    setLoadedData(data);

    if (savedFilters?.selectedFilters) {
      const restoredFilters = { ...savedFilters.selectedFilters };

      if (savedFilters.selectedFilters.organismoEmisorId) {
        restoredFilters.organismoEmisorId = data.organismos.find(
          o => o.id === savedFilters.selectedFilters.organismoEmisorId.id
        ) || null;
      }
      if (savedFilters.selectedFilters.tipoDocumentoId) {
        restoredFilters.tipoDocumentoId = data.tiposDocumento.find(
          t => t.id === savedFilters.selectedFilters.tipoDocumentoId.id
        ) || null;
      }
      if (savedFilters.selectedFilters.estadoTramitacionId) {
        restoredFilters.estadoTramitacionId = data.estadosTramitacion.find(
          e => e.id === savedFilters.selectedFilters.estadoTramitacionId.id
        ) || null;
      }
      if (savedFilters.selectedFilters.rubroId) {
        restoredFilters.rubroId = data.rubros.find(
          r => r.id === savedFilters.selectedFilters.rubroId.id
        ) || null;
      }
      if (savedFilters.selectedFilters.clasificacionDocumentoId) {
        restoredFilters.clasificacionDocumentoId = data.clasificaciones.find(
          c => c.id === savedFilters.selectedFilters.clasificacionDocumentoId.id
        ) || null;
      }
      if (savedFilters.selectedFilters.clienteId) {
        restoredFilters.clienteId = data.clientes.find(
          c => c.id === savedFilters.selectedFilters.clienteId.id
        ) || null;
      }

      setSelectedFilters(restoredFilters);
    }
  }, []);

  useEffect(() => {
    const filtersToSave = {
      searchTerm,
      filterHabilitado,
      startDate,
      endDate,
      page,
      rowsPerPage,
      selectedFilters,
      ordenarPor,
      ordenDireccion,
    };
    saveFiltersToStorage(filtersToSave);
  }, [searchTerm, filterHabilitado, startDate, endDate, page, rowsPerPage, selectedFilters, ordenarPor, ordenDireccion]);

  const fetchNormativas = useCallback(() => {
    setIsLoadingNormativas(true);
    const token = localStorage.getItem("token");

    const filters = {
      searchField,
      searchTerm,
      startDate,
      endDate,
      filterHabilitado,
      organismoEmisorId: selectedFilters.organismoEmisorId?.nombre || null,
      tipoDocumentoId: selectedFilters.tipoDocumentoId?.nombre || null,
      estadoTramitacionId: selectedFilters.estadoTramitacionId?.nombre || null,
      rubroId: selectedFilters.rubroId?.nombre || null,
      clasificacionDocumentoId: selectedFilters.clasificacionDocumentoId?.nombre || null,
      clienteId: selectedFilters.clienteId?.nombre || null,
      paisId: selectedFilters.paisId?.nombre || null,
      ordenarPor,
      ordenDireccion,
    };

    getDocumentos(page + 1, rowsPerPage, filters, token)
      .then((response) => {
        if (!response) {
          setDocumentos([]);
          setTotalCount(0);
          return;
        }
        setDocumentos(response.items || []);
        setTotalCount(response.totalCount || 0);
      })
      .catch((error) => {
        console.log(error);
        setDocumentos([]);
      })
      .finally(() => {
        setIsLoadingNormativas(false);
        setInitialLoadComplete(true);
      });
  }, [searchField, searchTerm, startDate, endDate, filterHabilitado, page, rowsPerPage, selectedFilters, ordenarPor, ordenDireccion]);

  useEffect(() => {
    fetchNormativas();
  }, [fetchNormativas]);

  const handleSearch = () => {
    setPage(0);
    fetchNormativas();
  };

  const setSearchTermWithPageReset = (value) => {
    setSearchTerm(value);
    setPage(0);
  };

  const setFilterHabilitadoWithPageReset = (value) => {
    setFilterHabilitado(value);
    setPage(0);
  };

  const setStartDateWithPageReset = (value) => {
    setStartDate(value);
    setPage(0);
  };

  const setEndDateWithPageReset = (value) => {
    setEndDate(value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleEdit = useCallback((id) => {
    navigate(`/editar-normativa/${id}`);
  }, [navigate]);

  const handleReanalizar = useCallback((id) => {
    setReanalizandoId(id);
    reanalizarImpacto(localStorage.getItem("token"), id)
      .then(() => {
        setReanalizadasIds((prev) => new Set(prev).add(id));
        mostrarNotificacion(
          "Análisis enviado a la cola. Se procesa en segundo plano; refresca en un momento para ver el resultado.",
          "info"
        );
      })
      .catch((e) => {
        mostrarNotificacion(typeof e === "string" ? e : "No se pudo reintentar el análisis", "error");
      })
      .finally(() => setReanalizandoId(null));
  }, [mostrarNotificacion]);

  const handleOpenDetalleNormativaModal = useCallback((normativa) => {
    setNormativaSeleccionado(normativa);
    setOpenDetalleNormativaModal(true);
  }, []);

  const handleCloseDetalleNormativaModal = useCallback(() => {
    setOpenDetalleNormativaModal(false);
    setNormativaSeleccionado(null);
  }, []);

  const handleDeleteConfirmation = (id) => {
    setNormativaToDelete(id);
    setOpenConfirmDialog(true);
  };

  const handleConfirmDelete = () => {
    if (normativaToDelete) {
      setIsLoadingNormativas(true);
      eliminarNormativa(localStorage.getItem("token"), normativaToDelete)
        .then((response) => {
          fetchNormativas();
          mostrarNotificacion(response.message || "Normativa eliminada correctamente", "success");
        })
        .catch((error) => {
          console.error("Error al eliminar normativa:", error);
          mostrarNotificacion(typeof error === 'string' ? error : "Error al eliminar normativa", "error");
        })
        .finally(() => {
          setIsLoadingNormativas(false);
          setOpenConfirmDialog(false);
          setNormativaToDelete(null);
        });
    }
  };

  const handleCancelDelete = () => {
    setOpenConfirmDialog(false);
    setNormativaToDelete(null);
  };

  const handleFilterChange = (field, value) => {
    setSelectedFilters(prev => ({
      ...prev,
      [field]: value
    }));
    setPage(0);
  };

  const resetFilters = () => {
    setSelectedFilters({
      organismoEmisorId: null,
      tipoDocumentoId: null,
      estadoTramitacionId: null,
      rubroId: null,
      clasificacionDocumentoId: null,
      clienteId: null,
    });
    setSearchTerm("");
    setFilterHabilitado("todos");
    setStartDate(null);
    setEndDate(null);
    setPage(0);
    setOrdenarPor(ORDEN_DEFECTO.ordenarPor);
    setOrdenDireccion(ORDEN_DEFECTO.ordenDireccion);

    sessionStorage.removeItem(FILTERS_STORAGE_KEY);
  };

  const handleSortFecha = () => {
    if (ordenarPor === "fechaPublicacion" && ordenDireccion === "desc") {
      setOrdenDireccion("asc");
    } else if (ordenarPor === "fechaPublicacion" && ordenDireccion === "asc") {
      setOrdenarPor(ORDEN_DEFECTO.ordenarPor);
      setOrdenDireccion(ORDEN_DEFECTO.ordenDireccion);
    } else {
      setOrdenarPor("fechaPublicacion");
      setOrdenDireccion("desc");
    }
    setPage(0);
  };

  const handleExportarExcel = () => {
    setIsDownloading(true);
    const token = localStorage.getItem("token");
    const filtros = {
      searchTerm,
      startDate,
      endDate,
      filterHabilitado,
      organismoEmisorId: selectedFilters.organismoEmisorId?.nombre || null,
      tipoDocumentoId: selectedFilters.tipoDocumentoId?.nombre || null,
      estadoTramitacionId: selectedFilters.estadoTramitacionId?.nombre || null,
      rubroId: selectedFilters.rubroId?.nombre || null,
      clasificacionDocumentoId: selectedFilters.clasificacionDocumentoId?.nombre || null,
      clienteId: selectedFilters.clienteId?.nombre || null,
      paisId: selectedFilters.paisId?.nombre || null,
      ordenarPor,
      ordenDireccion,
    };

    exportarDocumentosExcel(filtros, token)
      .then((blob) => {
        if (!(blob instanceof Blob)) {
          throw new Error("La respuesta no es un blob válido");
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Normativas_${new Date().toISOString().slice(0, 10)}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        mostrarNotificacion("Excel exportado correctamente", "success");
      })
      .catch((error) => {
        console.error("Error al exportar Excel:", error);
        mostrarNotificacion("Error al exportar el Excel", "error");
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  const botonReanalizar = (documento) => {
    const encolando = reanalizandoId === documento.id;
    const yaEnCola = reanalizadasIds.has(documento.id);

    if (yaEnCola) {
      return (
        <Tooltip title="En cola — se procesará en segundo plano">
          <Chip
            label="En cola"
            size="small"
            variant="outlined"
            color="info"
            sx={{ fontSize: '0.65rem', height: 22 }}
          />
        </Tooltip>
      );
    }

    return (
      <Tooltip title="Analizar con IA">
        <span>
          <IconButton
            size="small"
            color="primary"
            onClick={() => handleReanalizar(documento.id)}
            disabled={encolando}
          >
            {encolando ? <CircularProgress size={16} /> : <ReplayIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    );
  };

  const renderEstadoImpacto = (documento) => {
    const evaluada = Boolean(documento.evaluada);
    const enError = !evaluada && documento.estadoAnalisis === "Error";

    if (evaluada) {
      return (
        <Tooltip title="Evaluada">
          <Chip
            icon={<FactCheckIcon />}
            size="small"
            color="success"
            variant="filled"
            sx={{ fontSize: '0.7rem', height: 24, '& .MuiChip-label': { px: 0.75 } }}
          />
        </Tooltip>
      );
    }

    if (enError) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'center' }}>
          <Tooltip title={documento.mensajeAnalisis || "Error al evaluar"}>
            <Chip
              icon={<ErrorOutlineIcon />}
              size="small"
              color="error"
              variant="outlined"
              sx={{ fontSize: '0.7rem', height: 24, '& .MuiChip-label': { px: 0.75 } }}
            />
          </Tooltip>
          {botonReanalizar(documento)}
        </Box>
      );
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'center' }}>
        <Tooltip title="Pendiente de evaluación">
          <Chip
            icon={<PendingActionsIcon />}
            size="small"
            variant="outlined"
            sx={{
              fontSize: '0.7rem', height: 24, color: 'text.disabled',
              '& .MuiChip-label': { px: 0.75 },
              '& .MuiChip-icon': { color: 'text.disabled' },
            }}
          />
        </Tooltip>
        {botonReanalizar(documento)}
      </Box>
    );
  };

  const tableColumns = useMemo(() => [
    { id: 'id', label: 'ID', minWidth: 45, priority: 0 },
    { id: 'nombre', label: 'Nombre', minWidth: 150, priority: 1 },
    { id: 'organismoEmisor', label: 'Organismo', minWidth: 40, priority: 2 },
    { id: 'tipoDocumento', label: 'Tipo', minWidth: 100, priority: 4 },
    { id: 'estadoTramitacion', label: 'Estado', minWidth: 100, priority: 2 },
    {
      id: 'fechaPublicacion', label: 'Fecha', minWidth: 90, priority: 3, sortable: true,
      format: (value) => value ? new Date(value).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }) : ''
    },
    { id: 'rubros', label: 'Rubros', minWidth: 150, priority: 3 },
    { id: 'clientes', label: 'Clientes', minWidth: 150, priority: 3 },
    {
      id: 'compromisos', label: 'Comp', minWidth: 50, priority: 2,
      format: (value) => Array.isArray(value) ? value.length : 0
    },
    {
      id: 'obligaciones', label: 'Oblig', minWidth: 50, priority: 2,
      format: (value) => Array.isArray(value) ? value.length : 0
    },
    {
      id: 'evaluada', label: 'Impacto', minWidth: 110, priority: 2, align: 'center'
    },
    {
      id: 'actualizacionNorma', label: 'Actualización', minWidth: 80, priority: 3,
      format: (value) => value ? "Sí" : "No"
    },
    { id: 'pais', label: 'País', minWidth: 15, priority: 3 },
    {
      id: 'habilitado', label: 'Habilitado', minWidth: 80, priority: 2,
      format: (value) => value ? "Sí" : "No"
    },
    { id: 'acciones', label: 'Acciones', minWidth: 150, align: 'center', priority: 1 }
  ], []);

  const visibleColumns = useMemo(() => {
    if (isMobile) {
      return tableColumns.filter(col => col.priority <= 1);
    }
    if (isSmall) {
      return tableColumns.filter(col => col.priority <= 2);
    }
    if (isMedium) {
      return tableColumns.filter(col => col.priority <= 3);
    }
    return tableColumns;
  }, [tableColumns, isMobile, isSmall, isMedium]);

  const ordenActivoPublicacion = ordenarPor === "fechaPublicacion";

  const renderNoDataMessage = () => (
    <Paper sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="body1" color="text.secondary">
        No se encontraron normativas con los criterios de búsqueda actuales.
      </Typography>
    </Paper>
  );

  const renderMobileCard = (documento) => (
    <Card key={documento.id} sx={{ mb: 2 }}>
      <CardContent sx={{ pb: 1 }}>
        <Typography variant="h6" sx={{
          wordBreak: "break-word",
          mb: 1,
          fontSize: "1rem"
        }}>
          {documento.nombre}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Grid container spacing={1}>

          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Estado:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.estadoTramitacion}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Organismo:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.organismoEmisor}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Tipo:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.tipoDocumento}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Fecha:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.fechaPublicacion ? new Date(documento.fechaPublicacion).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }) : ''}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Habilitado:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.habilitado ? "Sí" : "No"}
            </Typography>
          </Grid>

          {documento.clientes && documento.clientes.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Clientes:
              </Typography>
              <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {documento.clientes.map((cliente, index) => (
                  <Chip
                    key={index}
                    label={cliente.nombre}
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: '0.7rem', height: 24 }}
                  />
                ))}
              </Box>
            </Grid>
          )}

          {documento.compromisos && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Compromisos:
              </Typography>
              <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                <Chip
                  key={documento.id}
                  label={documento.compromisos.length ?? 0}
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: '0.7rem', height: 24 }}
                />
              </Box>
            </Grid>
          )}

          {documento.obligaciones && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Obligaciones:
              </Typography>
              <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                <Chip
                  key={documento.id}
                  label={documento.obligaciones.length ?? 0}
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: '0.7rem', height: 24 }}
                />
              </Box>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Impacto:
            </Typography>
            <Box sx={{ mt: 0.5 }}>
              {renderEstadoImpacto(documento)}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        p: 1.5,
        alignItems: 'stretch'
      }}>
        <Button
          sx={{ mx: 1 }}
          variant="contained"
          size="small"
          onClick={() => handleOpenDetalleNormativaModal(documento)}
          startIcon={<VisibilityIcon />}
          fullWidth
        >
          Detalle
        </Button>

        {documento.url && (
          <Button
            variant="outlined"
            size="small"
            component="a"
            href={documento.url}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<OpenInNewIcon />}
            fullWidth
          >
            Ver documento
          </Button>
        )}

        <Button
          variant="outlined"
          size="small"
          onClick={() => handleEdit(documento.id)}
          startIcon={<EditNoteIcon />}
          fullWidth
        >
          Editar
        </Button>

        <Button
          variant="contained"
          size="small"
          color="error"
          onClick={() => handleDeleteConfirmation(documento.id)}
          startIcon={<DeleteForeverIcon />}
          fullWidth
        >
          Eliminar
        </Button>
      </CardActions>
    </Card>
  );

  const renderRubros = (rubros, todosLosRubros) => {
    if (!rubros || !Array.isArray(rubros) || rubros.length === 0) {
      return null;
    }

    const todosLosRubrosHabilitados = todosLosRubros.filter(rubro => rubro.habilitado);
    const aplicaATodos = rubros.length === todosLosRubrosHabilitados.length &&
      todosLosRubrosHabilitados.every(rubroTotal =>
        rubros.some(rubroDoc => rubroDoc.id === rubroTotal.id)
      );

    if (aplicaATodos) {
      return (
        <Chip
          label="Aplica a todos"
          size="small"
          variant="filled"
          color="primary"
          sx={{
            fontSize: '0.75rem',
            height: 24,
            '& .MuiChip-label': {
              padding: '0 8px'
            }
          }}
        />
      );
    }

    const rubrosAMostrar = rubros.slice(0, 5);
    const hayMas = rubros.length > 5;

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {rubrosAMostrar.map((rubro, idx) => (
          <Chip
            key={idx}
            label={rubro.nombre}
            size="small"
            variant="outlined"
            sx={{
              fontSize: '0.75rem',
              height: 24,
              '& .MuiChip-label': {
                padding: '0 8px'
              }
            }}
          />
        ))}
        {hayMas && (
          <Chip
            label={`+${rubros.length - 5} más`}
            size="small"
            variant="filled"
            color="secondary"
            sx={{
              fontSize: '0.75rem',
              height: 24,
              '& .MuiChip-label': {
                padding: '0 8px'
              }
            }}
          />
        )}
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        p: { xs: 1, sm: 2 }
      }}
    >
      <DataLoader onDataLoaded={handleDataLoaded} />

      <Box sx={{ flexShrink: 0, mb: 2 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Gestor de normativa</Typography>

        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>Filtros</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                fullWidth
                label="Buscar por nombre o código"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={(e) => setSearchTermWithPageReset(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch();
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Estado</InputLabel>
                <Select
                  value={filterHabilitado}
                  onChange={(e) => setFilterHabilitadoWithPageReset(e.target.value)}
                  label="Estado"
                >
                  <MenuItem value="todos">Todos</MenuItem>
                  <MenuItem value="habilitado">Habilitados</MenuItem>
                  <MenuItem value="deshabilitado">Deshabilitados</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.organismos || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Organismo emisor" size="small" />}
                  value={selectedFilters.organismoEmisorId}
                  onChange={(event, newValue) => handleFilterChange("organismoEmisorId", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.tiposDocumento || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Tipo de documento" size="small" />}
                  value={selectedFilters.tipoDocumentoId}
                  onChange={(event, newValue) => handleFilterChange("tipoDocumentoId", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.estadosTramitacion || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Estado de tramitación" size="small" />}
                  value={selectedFilters.estadoTramitacionId}
                  onChange={(event, newValue) => handleFilterChange("estadoTramitacionId", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.clasificaciones || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Clasificación" size="small" />}
                  value={selectedFilters.clasificacionDocumentoId}
                  onChange={(event, newValue) => handleFilterChange("clasificacionDocumentoId", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.rubros || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Rubro" size="small" />}
                  value={selectedFilters.rubroId}
                  onChange={(event, newValue) => handleFilterChange("rubroId", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.clientes || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Cliente" size="small" />}
                  value={selectedFilters.clienteId}
                  onChange={(event, newValue) => handleFilterChange("clienteId", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.paises || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="País" size="small" />}
                  value={selectedFilters.paisId}
                  onChange={(event, newValue) => handleFilterChange("paisId", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  sx={{ width: "100%" }}
                  format="dd/MM/yyyy"
                  label="Fecha Desde"
                  value={startDate}
                  onChange={(newValue) => setStartDateWithPageReset(newValue)}
                  slotProps={{ textField: { size: 'small' } }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  sx={{ width: "100%" }}
                  format="dd/MM/yyyy"
                  label="Fecha Hasta"
                  value={endDate}
                  onChange={(newValue) => setEndDateWithPageReset(newValue)}
                  slotProps={{ textField: { size: 'small' } }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} container spacing={1} sx={{ mt: 1 }}>
              <Grid item xs={6} sm={3} md={2}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={resetFilters}
                  size="small"
                >
                  Limpiar filtros
                </Button>
              </Grid>

              <Grid item xs={6} sm={3} md={2}>
                <Button
                  variant="contained"
                  color="success"
                  fullWidth
                  onClick={handleExportarExcel}
                  startIcon={<DownloadIcon />}
                  disabled={isDownloading}
                  size="small"
                >
                  {isDownloading ? <CircularProgress size={24} /> : "Excel"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Box sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden'
      }}>
        {(!initialLoadComplete || isLoadingNormativas) ? (
          <Box display="flex" justifyContent="center" alignItems="center" sx={{ flex: 1 }}>
            <CircularProgress />
          </Box>
        ) : documentos.length > 0 ? (
          <>
            {isMobile ? (
              <Box sx={{
                flex: 1,
                overflow: 'auto',
                pr: 1
              }}>
                {documentos.map(renderMobileCard)}
              </Box>
            ) : (
              <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }}>
                <TableContainer
                  component={Paper}
                  sx={{
                    flex: 1,
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    overflowX: 'auto',
                    '& .MuiTable-root': {
                      minWidth: 'max-content',
                    }
                  }}
                >
                  <Table
                    stickyHeader
                    size="small"
                    sx={{
                      flex: 1,
                      '& .MuiTableBody-root': {
                        flex: 1
                      }
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        {visibleColumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align || 'left'}
                            sortDirection={column.sortable && ordenActivoPublicacion ? ordenDireccion : false}
                            sx={{
                              minWidth: column.minWidth,
                              padding: '10px 8px',
                              whiteSpace: 'normal',
                              overflowWrap: 'break-word',
                              fontWeight: 'bold',
                              backgroundColor: theme.palette.background.paper,
                              zIndex: 1,
                              position: 'sticky',
                              top: 0,
                              ...(column.id === 'id' && {
                                left: 0,
                                zIndex: 3,
                              }),
                              ...(column.id === 'nombre' && {
                                left: 45,
                                zIndex: 3,
                                borderRight: `1px solid ${theme.palette.divider}`,
                              }),
                            }}
                          >
                            {column.sortable ? (
                              <Tooltip
                                title={
                                  ordenActivoPublicacion
                                    ? "Ordenar por fecha de publicación (clic para alternar; vuelve al orden por creación)"
                                    : "Ordenar por fecha de publicación"
                                }
                              >
                                <TableSortLabel
                                  active={ordenActivoPublicacion}
                                  direction={ordenActivoPublicacion ? ordenDireccion : "desc"}
                                  onClick={handleSortFecha}
                                >
                                  {column.label}
                                </TableSortLabel>
                              </Tooltip>
                            ) : (
                              column.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {documentos.map((documento) => (
                        <TableRow
                          key={documento.id}
                          hover
                          sx={{
                            '&:nth-of-type(odd)': {
                              backgroundColor: theme.palette.action.hover,
                            },
                          }}
                        >
                          {visibleColumns.map((column) => {
                            if (column.id === 'acciones') {
                              return (
                                <TableCell
                                  key={column.id}
                                  align={column.align || 'left'}
                                  sx={{ padding: '4px 8px' }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: {
                                        xs: 'column',
                                        sm: 'row'
                                      },
                                      flexWrap: 'wrap',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      gap: 0.5
                                    }}
                                  >
                                    <Tooltip title="Ver detalle">
                                      <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() => handleOpenDetalleNormativaModal(documento)}
                                      >
                                        <VisibilityIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    {documento.url && (
                                      <Tooltip title="Ver documento">
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          component="a"
                                          href={documento.url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <OpenInNewIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    <Tooltip title="Editar">
                                      <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() => handleEdit(documento.id)}
                                      >
                                        <EditNoteIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Eliminar">
                                      <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() => handleDeleteConfirmation(documento.id)}
                                      >
                                        <DeleteForeverIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                              );
                            }

                            const value = column.id.includes('.')
                              ? column.id.split('.').reduce((obj, key) => obj && obj[key], documento)
                              : documento[column.id];

                            return (
                              <TableCell
                                key={column.id}
                                align={column.align || 'left'}
                                sx={{
                                  padding: '8px',
                                  maxWidth: column.id === 'nombre' ? '250px' : '150px',
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  ...(column.id === 'id' && {
                                    position: 'sticky',
                                    left: 0,
                                    backgroundColor: theme.palette.background.paper,
                                    zIndex: 1,
                                  }),
                                  ...(column.id === 'nombre' && {
                                    position: 'sticky',
                                    left: 45,
                                    backgroundColor: theme.palette.background.paper,
                                    zIndex: 1,
                                    borderRight: `1px solid ${theme.palette.divider}`,
                                    maxWidth: '200px',
                                  }),
                                }}
                              >
                                {column.id === 'clientes' ? (
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {value && Array.isArray(value) ?
                                      value.map((cliente, idx) => (
                                        <Chip
                                          key={idx}
                                          label={cliente.nombre}
                                          size="small"
                                          variant="outlined"
                                          sx={{
                                            fontSize: '0.75rem',
                                            height: 24,
                                            '& .MuiChip-label': {
                                              padding: '0 8px'
                                            }
                                          }}
                                        />
                                      )) : null
                                    }
                                  </Box>
                                ) : column.id === 'rubros' ? (
                                  renderRubros(value, loadedData.rubros || [])
                                ) : column.id === 'evaluada' ? (
                                  renderEstadoImpacto(documento)
                                ) : (
                                  column.format ? column.format(value) : value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            <Box sx={{
              flexShrink: 0,
              backgroundColor: theme.palette.background.paper,
              borderTop: `1px solid ${theme.palette.divider}`
            }}>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              />
            </Box>
          </>
        ) : (
          <Box sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {renderNoDataMessage()}
          </Box>
        )}
      </Box>

      {openDetalleNormativaModal && (
        <Suspense fallback={
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        }>
          <LazyDetalleNormativaModal
            open={openDetalleNormativaModal}
            onClose={handleCloseDetalleNormativaModal}
            normativa={normativaSeleccionado}
            isLoading={isLoadingNormativas}
          />
        </Suspense>
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={handleCancelDelete}
      >
        <DialogTitle>{"¿Eliminar normativa?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea eliminar esta normativa? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="error" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GestorNormativa;